export default __webpack_public_path__ + "static/media/responsive.75ee2980.png";